import { HiveCanvasLayout } from './canvas/HiveCanvasLayout.js';
import { HiveOverlay } from './HiveOverlay.js';
import { useHoneycombLoading } from '../hooks/use-honeycomb-loading.js';
import { HiveProviders } from '../providers/hive.providers.js';

export const HoneycombHive = () => {
  const loading = useHoneycombLoading();
  return (
    <HiveProviders>
      <HiveCanvasLayout />
      {loading ? null : <HiveOverlay />}
    </HiveProviders>
  );
};

HoneycombHive['displayName'] = 'HoneycombHive';
